import type { IndividualProfileSummary } from "@rbim/shared";

export type IndividualRecordCertificateData = {
  issuedDate: string;
  location: {
    province: string;
    cityMunicipality: string;
    barangay: string;
    householdNumber: string;
  };
  personal: {
    lastName: string;
    firstName: string;
    middleName: string;
    address: string;
    dateOfBirth: string;
    age: string;
    placeOfBirth: string;
    sex: string;
    civilStatus: string;
    occupation: string;
    citizenship: string;
    relationshipToHouseholdHead: string;
  };
  photoUrl: string;
};

export function buildIndividualRecordCertificateData(
  resident: IndividualProfileSummary,
  issuedAt = new Date(),
): IndividualRecordCertificateData {
  return {
    issuedDate: issuedAt.toLocaleDateString("en-PH", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }),
    location: {
      province: certificateValue(resident.province),
      cityMunicipality: certificateValue(resident.cityMunicipality),
      barangay: certificateValue(resident.barangayName),
      householdNumber: certificateValue(resident.householdCode),
    },
    personal: {
      lastName: certificateValue(resident.lastName),
      firstName: certificateValue(resident.firstName),
      middleName: certificateValue(resident.middleName),
      address: [resident.address, resident.purok, resident.barangayName, resident.cityMunicipality, resident.province]
        .map(certificateValue)
        .filter(Boolean)
        .join(", "),
      dateOfBirth: certificateValue(resident.dateOfBirth),
      age: resident.age === null ? "" : certificateValue(resident.age),
      placeOfBirth: certificateValue(resident.placeOfBirth),
      sex: certificateValue(resident.sex),
      civilStatus: certificateValue(resident.civilStatus),
      occupation: certificateValue(resident.occupation),
      citizenship: certificateValue(resident.citizenship),
      relationshipToHouseholdHead: certificateValue(resident.relationshipToHead),
    },
    photoUrl: certificateValue(resident.photoUrl),
  };
}

function certificateValue(value: unknown) {
  const normalized = typeof value === "string"
    ? value.replace(/\s+/g, " ").trim()
    : String(value ?? "").trim();
  return /^(none|null|undefined|n\/a|na|99|99\s*-\s*n\/a)$/i.test(normalized)
    || /^hh-sub(?:-|$)/i.test(normalized.replace(/_/g, "-"))
    ? ""
    : normalized;
}
